<template>
    <main>
        <header class="header">
            <DemoBar />
            <div class="bg-warning p-2" v-if="$page.props.auth.isAuthorizedFromAdmin">
                <inertia-link class="no-underline" :href="route('nl.employerdashboard.logout')">
                    <div class="container font-size-12 color-dark-blue">
                        <i class="fa fa-user"></i>
                        <strong class="font-poppins font-weight-bold pr-3 pl-1 pt-1">
                            {{ Lang.get('employerdashboard::shared.authorized_as', {
                                'companyRepresentativeFullName' : $page.props.auth.user.fullname,
                        }) }}
                        </strong>
                    </div>
                </inertia-link>
            </div>
            <div class="bg-danger p-2" v-if="$page.props.auth.isAuthorizedFromScp">
                <div class="container font-size-12 color-white">
                    <i class="fa fa-user"></i>
                    <strong class="font-poppins font-weight-bold pr-3 pl-1 pt-1">
                        {{ Lang.get('employerdashboard::shared.authorized_as_scp', {
                            'first_name' : $page.props.auth.user.first_name,
                    }) }}
                    </strong>
                </div>
            </div>

            <div class="bg-red p-2" v-for="(problem, key) in problemsBag.problem_with_provider">
                <inertia-link class="no-underline" :href="problem.link">
                    <div class="container font-size-12 color-white">
                        <img src="/img/employer-dashboard/icon-error-message.svg">
                        <strong class="font-poppins font-weight-bold pr-3 pl-1 pt-1">
                            {{ problem.title }}
                        </strong> {{ problem.description }}
                    </div>
                </inertia-link>
            </div>
            <top-nav :url="url()"></top-nav>
            <div class="bg-warning">
                <terminated-bar></terminated-bar>
            </div>
        </header>
        <article>
            <slot />
        </article>
        <footer class="footer">
            <div class="container">
                <nav class="nav float-left">
                    <inertia-link class="nav-link color-light-blue font-aileron-bold font-size-12 py-0" :href="route('nl.employerdashboard.logout')">{{ Lang.get('employerdashboard::shared.layout.footer.logout') }}</inertia-link>
                </nav>
                <span class="font-aileron color-light-blue font-size-12 float-right py-0">
                {{ Lang.get('employerdashboard::shared.layout.footer.copyright') }}
                </span>
            </div>
        </footer>
    </main>
</template>

<script>
import TopNav from "@/Shared/TopNav";
import DemoBar from '@/Shared/DemoBar';
import TerminatedBar from "@/Shared/TerminatedBar";

export default {

    components: {
        TerminatedBar,
        TopNav,
        DemoBar
    },
    props: {
        title: {
            type: String,
            default() {
                return this.$page.props.auth.user.selected_company.title;
            }
        },
    },

    data: function () {
        return {
            problemsBag: this.$page.props.problems,
        }
    },

    watch: {
        title: {
            immediate: true,
            handler(title) {
                document.title = title
            },
        },
    },
    methods: {
        url() {
            return location.href;
        },
    },

    mounted () {
        document.body.classList.remove('background-company')
        document.body.classList.remove('background-company-login')
    },

    destroyed () {
        document.body.classList.add('background-company')
        document.body.classList.add('background-company-login')
    }
}
</script>
